import { $applyNodeReplacement, DecoratorNode } from "lexical"

export class ImageNode extends DecoratorNode {
  __objectKey
  __src
  __alt

  static getType() {
    return "image"
  }

  static clone(node) {
    return new ImageNode(
      { objectKey: node.__objectKey, src: node.__src, alt: node.__alt },
      node.__key,
    )
  }

  static importJSON(serialized) {
    return $createImageNode({
      objectKey: serialized.objectKey ?? "",
      src: serialized.src ?? "",
      alt: serialized.alt ?? "",
    })
  }

  constructor({ objectKey = "", src = "", alt = "" } = {}, key) {
    super(key)
    this.__objectKey = objectKey
    this.__src = src
    this.__alt = alt
  }

  exportJSON() {
    return {
      type: ImageNode.getType(),
      version: 1,
      objectKey: this.__objectKey,
      src: this.__src,
      alt: this.__alt,
    }
  }

  createDOM() {
    const figure = document.createElement("figure")
    figure.className = "lexical-image"
    return figure
  }

  updateDOM() {
    return false
  }

  decorate() {
    const img = document.createElement("img")
    img.src = this.__src
    img.alt = this.__alt
    img.draggable = false
    img.dataset.objectKey = this.__objectKey
    return img
  }

  isInline() {
    return false
  }

  isKeyboardSelectable() {
    return true
  }
}

export function $createImageNode({ objectKey, src = "", alt = "" }) {
  return $applyNodeReplacement(new ImageNode({ objectKey, src, alt }))
}

export function $isImageNode(node) {
  return node instanceof ImageNode
}
